import { useQuery } from "hooks/useQuery";
import { getStrategyCollection } from "features/Strategy/service";

export const useStrategyCollection = () => {
  const { data, isLoading } = useQuery({
    key: "strategyCollection",
    queryKey: ["strategyCollection"],
    queryFn: async () => {
      const response = await getStrategyCollection();
      return {
        mainBanner: response?.main_banner,
        strategyCards: response?.strategy_cards,
      };
    },
  });

  return { data, isLoading };
};
